module.exports = __webpack_public_path__ + "static/media/9.60ee0f74.JPG";